import * as Icons from "lucide-react";
import { ChevronRight } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";
import { WORKSPACE_FLOW } from "@/data/content";

export const ConnectedWorkspace = () => {
  return (
    <section id="workspace" data-testid="workspace-section" className="relative py-24 sm:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <Reveal><Overline>Connected Workspace</Overline></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 text-4xl sm:text-5xl font-semibold font-heading tracking-tight leading-tight text-slate-900">
              One continuous flow, from supplier to shipment.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed">
              Verified Manufacturers™ connects seamlessly with every DeMaxtore Workspace Product, so nothing is lost between sourcing and delivery.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.1}>
          <div className="mt-16 flex flex-col lg:flex-row lg:flex-wrap lg:justify-center items-stretch gap-3 lg:gap-2">
            {WORKSPACE_FLOW.map((node, i) => {
              const Icon = Icons[node.icon] || Icons.Circle;
              const isFirst = i === 0;
              const isLast = i === WORKSPACE_FLOW.length - 1;
              return (
                <div key={node.name} className="flex flex-col lg:flex-row items-center gap-3 lg:gap-2">
                  <div data-testid={`workspace-node-${i}`} className={`w-full lg:w-[168px] h-full flex flex-col items-center text-center rounded-2xl border p-5 transition-all duration-300 hover:-translate-y-1 ${isFirst ? "bg-blue-600 border-blue-600 text-white shadow-[0_16px_36px_rgba(37,99,235,0.28)]" : isLast ? "bg-emerald-50 border-emerald-100" : "bg-white border-slate-200/80 hover:shadow-[0_16px_36px_rgba(15,23,42,0.08)] hover:border-blue-200"}`}>
                    <span className={`flex items-center justify-center w-11 h-11 rounded-xl mb-3 ${isFirst ? "bg-white/15 text-white" : isLast ? "bg-emerald-600 text-white" : "bg-slate-50 text-blue-600 border border-slate-100"}`}><Icon className="w-5 h-5" /></span>
                    <div className={`text-sm font-semibold ${isFirst ? "text-white" : "text-slate-900"}`}>{node.name}</div>
                    <div className={`mt-1 text-[11px] leading-snug ${isFirst ? "text-blue-100" : "text-slate-500"}`}>{node.role}</div>
                  </div>
                  {!isLast && (<ChevronRight className="w-5 h-5 text-slate-300 shrink-0 rotate-90 lg:rotate-0" />)}
                </div>
              );
            })}
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default ConnectedWorkspace;
